/* eslint-disable prettier/prettier */
import Cookies, { CookieAttributes } from 'js-cookie';

import Result, { EmptyResult } from '../Result';

export class Record {
  public constructor(
    public readonly key: string,
    public readonly value: string,
    public readonly options?: CookieAttributes,
  ) {}
}

export type Storage = {
  put(record: Record): Promise<Result>;
  remove(record: { key: string; options?: CookieAttributes }): Promise<EmptyResult>;
  get(key: string): Promise<Result<string | undefined>>;
  getName(): string;
};

export default class CookieStorage implements Storage {
  public constructor() {}

  private getSSRCookie(cName: string, cookie: string) {
    const name = `${cName}=`;
    const cDecoded = decodeURIComponent(cookie);
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach((val) => {
      if (val.startsWith(name)) res = val.substring(name.length);
    });
    return res;
  }

  public getName(): string {
    return 'CookieStorage';
  }

  public async put({ key, value, options }: Record): Promise<Result> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    Cookies.set(key, value, options);

    return new EmptyResult();
  }

  public async get(key: string, ssrCookie?: string): Promise<Result<string | undefined>> {
    let value = Cookies.get(key);

    if (!value && ssrCookie) {
      value = this.getSSRCookie(key, ssrCookie);
      return new Result(value);
    }

    return new Result(value);
  }

  public async remove({ key, options }: { key: string; options?: CookieAttributes }): Promise<EmptyResult> {
    Cookies.remove(key, options);

    return new EmptyResult();
  }
}
